import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { CommunicationsTab } from "./CommunicationsTab";
import { StudentMedicalTab } from "./StudentMedicalTab";
import { StudentGeneralNotesTab } from "./StudentGeneralNotesTab";
import { HardCopyAccessTab } from "./HardCopyAccessTab";

export function LogsTab({ studentId, studentName, generalNotes, userId, onUpdated }) {
  return (
    <div className="space-y-4" data-testid="student-logs-tab">
      <Tabs defaultValue="communications" className="space-y-4">
        <TabsList className="flex flex-wrap gap-1 h-auto p-1">
          <TabsTrigger value="communications" data-testid="logs-subtab-communications">Communications</TabsTrigger>
          <TabsTrigger value="medical" data-testid="logs-subtab-medical">OTC / Medical</TabsTrigger>
          <TabsTrigger value="general-notes" data-testid="logs-subtab-general-notes">General Notes</TabsTrigger>
          <TabsTrigger value="hardcopy-access" data-testid="logs-subtab-hardcopy-access">Hard Copy Access</TabsTrigger>
        </TabsList>

        <TabsContent value="communications">
          <CommunicationsTab studentId={studentId} studentName={studentName} />
        </TabsContent>

        <TabsContent value="medical">
          <StudentMedicalTab studentId={studentId} />
        </TabsContent>

        <TabsContent value="general-notes">
          <StudentGeneralNotesTab studentId={studentId} notes={generalNotes} userId={userId} onUpdated={onUpdated} />
        </TabsContent>

        <TabsContent value="hardcopy-access">
          <HardCopyAccessTab studentId={studentId} studentName={studentName} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
